import { FieldLabel } from "@/components/forms/field-label";
import { cn } from "@/lib/cn";

interface ProFieldProps {
  label: string;
  help?: string;
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
  required?: boolean;
}

function ProField({ label, help, children, className, htmlFor, required }: ProFieldProps) {
  const labelClassName = "field-label text-[12px] font-semibold text-pro-text-secondary";

  return (
    <div className={cn("field flex flex-col gap-1.5", className)}>
      <FieldLabel htmlFor={htmlFor} required={required} tone="pro" className={labelClassName}>
        {label}
      </FieldLabel>
      {children}
      {help && <span className="field-help text-[11px] text-pro-text-faint">{help}</span>}
    </div>
  );
}

export { ProField, type ProFieldProps };
